import React, { useState } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { useForm, Controller } from 'react-hook-form'
import { Panel, Form, Message, Row } from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import ReviewSummaryForm from '../../components/forms/reviewSummaryForm/ReviewSummaryForm'
import { saveReviewResult, saveReviewResultMuti } from '../../redux/actions/reviewSummary'
import { startLoading, doneLoading } from '../../utils/loading'
import ConfirmWidget from '../confirm/ConfirmWidget'

export default function ReviewResult({ schema, onComplete = () => {}, projectVersionIdList }) {
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [submitData, setSubmitData] = useState()
  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(schema)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleSaveReviewSummary = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response = await saveReviewResultMuti(request)
      // console.log('response', response)
      // if (typeof onComplete === 'function') {
      onComplete(response, projectVersionIdList)
      // }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleRequest = (data) => {
    let ids = projectVersionIdList || [projectId]
    const request = {
      projectVersionIds: ids,
      descriptionSummary: data.reviewResult,
      selectedOption: data.reviewerFilter,
    }

    // console.log('request', JSON.stringify(request))
    handleSaveReviewSummary(request)
  }

  const onSubmit = (data) => {
    setSubmitData(data)
    setIsShowConfirm(true)
  }

  const onConfirm = () => {
    setIsShowConfirm(false)
    handleRequest(submitData)
  }

  const onCancle = () => {
    setSubmitData()
    setIsShowConfirm(false)
  }

  return (
    <>
      <Form fluid>
        <Panel shaded header={formSchema.header} bordered collapsible defaultExpanded>
          <ReviewSummaryForm
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
          <hr />
          {isError && (
            <Row style={{ marginBottom: 10 }}>
              <Message
                showIcon
                type="error"
                description={'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'}
              />
            </Row>
          )}
          <SaveButton onClick={handleSubmit(onSubmit)} disabled={isLoading}>
            {formSchema.buttonText || 'บันทึกผลการพิจารณากลั่นกรอง'}
          </SaveButton>
        </Panel>
        <br />
      </Form>

      <ConfirmWidget
        title={`ยืนยันการบันทึกผลการพิจารณากลั่นกรอง`}
        show={isShowConfirm}
        detail={`กรุณายืนยันการบันทึกผลการพิจารณากลั่นกรอง`}
        onCancle={onCancle}
        onConfirm={onConfirm}
      />
    </>
  )
}
